import React, { useMemo } from 'react';
import { Image } from 'react-konva';
import useImage from 'use-image';
// Component for each product image
const StaticImage = ({ imageData, canvasScaler, imageRef }) => {
    const [canvasImage] = useImage(imageData.uploadedImage, 'anonymous');
    const cachedImage = useMemo(() => canvasImage, [canvasImage]);
    if (imageData.uploadedImage == null) {
        return null;
    }
    return (React.createElement(Image, { ref: imageRef, width: imageData.position.width * canvasScaler, height: imageData.position.height * canvasScaler, x: imageData.position.pos_x * canvasScaler, y: imageData.position.pos_y * canvasScaler, rotation: imageData.position.rotation, offsetY: (imageData.position.height * canvasScaler) / 2, offsetX: (imageData.position.width * canvasScaler) / 2, image: cachedImage, fill: "transparent" }));
};
export default StaticImage;
